export enum SatBootcampPersistedScreen {
  PAYWALL = 'PAYWALL',
  FREE_ACCESS_OFFER = 'FREE_ACCESS_OFFER',
}
